import React from "react";
import {
    Box,
    Typography,
    CardContent,
    Grid,
    Button,
    Paper,
} from "@mui/material";
import Draggable from "react-draggable";

const ProductDetailsCard = ({ productData, onClose, onPrint }) => {
    if (!productData) return null;

    return (
        <Draggable>
            <Paper
                sx={{
                    position: "absolute",
                    top: "20%",
                    left: "50%",
                    transform: "translate(-50%, -20%)",
                    zIndex: 1300,
                    width: "90%",
                    maxWidth: "800px",
                    boxShadow: 6,
                    borderRadius: "12px",
                    backgroundColor: "#ffffff",
                }}
            >
                <CardContent sx={{ padding: "20px" }}>
                    {/* Logo and Product Image */}
                    <Box sx={{ textAlign: "center", marginBottom: "20px" }}>
                        <img
                            src="https://figk-12.com/static/media/fig_CROP.cb0d7cf4314c63ba05ee.png"
                            alt="Product Placeholder"
                            style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "contain",
                                border: "1px solid #ddd",
                                borderRadius: "8px",
                            }}
                        />
                    </Box>

                    {/* Product Title */}
                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: "bold",
                            textAlign: "center",
                            marginBottom: "20px",
                            color: "#004085", // FIG Navy Blue
                        }}
                    >
                        {productData.description || "Unknown Product"}
                    </Typography>

                    {/* General Information Section */}
                    <Box sx={{ marginBottom: "20px" }}>
                        <Typography
                            variant="h6"
                            sx={{
                                color: "#ffffff",
                                fontWeight: "bold",
                                backgroundColor: "#007bff", // FIG Blue Background
                                padding: "10px",
                                borderRadius: "5px",
                                textAlign: "center",
                            }}
                        >
                            General Information
                        </Typography>
                        <Grid container spacing={2} sx={{ marginTop: "10px" }}>
                            <Grid item xs={12} sm={4}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontWeight: "bold",
                                        color: "#004085", // FIG Navy Blue
                                    }}
                                >
                                    FDC ID:
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        padding: "8px",
                                        border: "1px solid #ddd",
                                        borderRadius: "5px",
                                        backgroundColor: "#f9f9f9", // Light Background
                                        color: "#333", // Dark Font
                                    }}
                                >
                                    {productData.fdcId || "N/A"}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontWeight: "bold",
                                        color: "#004085",
                                    }}
                                >
                                    Brand:
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        padding: "8px",
                                        border: "1px solid #ddd",
                                        borderRadius: "5px",
                                        backgroundColor: "#f9f9f9",
                                        color: "#333",
                                    }}
                                >
                                    {productData.brandName || "N/A"}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontWeight: "bold",
                                        color: "#004085",
                                    }}
                                >
                                    Data Type:
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        padding: "8px",
                                        border: "1px solid #ddd",
                                        borderRadius: "5px",
                                        backgroundColor: "#f9f9f9",
                                        color: "#333",
                                    }}
                                >
                                    {productData.dataType || "N/A"}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>

                    {/* Nutritional Information Section */}
                    <Box sx={{ marginBottom: "20px" }}>
                        <Typography
                            variant="h6"
                            sx={{
                                color: "#ffffff",
                                fontWeight: "bold",
                                backgroundColor: "#007bff",
                                padding: "10px",
                                borderRadius: "5px",
                                textAlign: "center",
                            }}
                        >
                            Nutritional Information
                        </Typography>
                        <Grid container spacing={2} sx={{ marginTop: "10px" }}>
                            {productData.foodNutrients &&
                                productData.foodNutrients.map((nutrient, index) => (
                                    <Grid item xs={12} sm={4} key={index}>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontWeight: "bold",
                                                color: "#004085",
                                            }}
                                        >
                                            {nutrient.nutrientName}:
                                        </Typography>
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                padding: "8px",
                                                border: "1px solid #ddd",
                                                borderRadius: "5px",
                                                backgroundColor: "#f9f9f9",
                                                color: "#333",
                                            }}
                                        >
                                            {nutrient.value} {nutrient.unitName}
                                        </Typography>
                                    </Grid>
                                ))}
                        </Grid>
                    </Box>

                    {/* Ingredients Section */}
                    {productData.ingredients && (
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    color: "#ffffff",
                                    fontWeight: "bold",
                                    backgroundColor: "#007bff",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    textAlign: "center",
                                }}
                            >
                                Ingredients
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    padding: "12px",
                                    border: "1px solid #ddd",
                                    borderRadius: "5px",
                                    backgroundColor: "#f9f9f9",
                                    whiteSpace: "pre-wrap",
                                    marginTop: "10px",
                                    color: "#333",
                                }}
                            >
                                {productData.ingredients}
                            </Typography>
                        </Box>
                    )}

                    {/* Action Buttons */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "20px",
                        }}
                    >
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: "#007bff",
                                color: "#fff",
                                marginRight: "10px",
                                "&:hover": { backgroundColor: "#0056b3" },
                            }}
                            onClick={onPrint}
                        >
                            Print
                        </Button>
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={onClose}
                        >
                            Close
                        </Button>
                    </Box>
                </CardContent>
            </Paper>
        </Draggable>
    );
};

export default ProductDetailsCard;
